import React, { useContext } from "react"
import ContentCard, { CardTitle } from "../ContentCard"
import { Link } from "react-router-dom"
import AppContext from "../../shared/AppContext"

export default function Dashboard(props) {
  const { trackEvent } = useContext(AppContext)
  let customElements = []

  if (props.children) {
    customElements = props.children.map((item, i) => {
      return React.cloneElement(item, {
        key: i,
        className: "favorites-list-item",
        ...item.props,
      })
    })
  }

  const renderElements = () => {
    if (customElements.length) {
      return customElements.map((item) => item)
    }

    return <p>No favorites to display.</p>
  }

  return (
    <ContentCard style={{ marginBottom: "2rem" }} data-cy="favorite-dashboard">
      <CardTitle
        title="Favorites"
        link={"/favorites"}
        location="dashboard favorites"
        data-cy="favorite-dashboard-title"
      />

      <div className="favorites-list">{renderElements()}</div>
      {!!customElements.length && (
        <Link
          className="view-all-link"
          to="/favorites"
          onClick={() => {
            trackEvent("Dashboard Favorites Link", {
              text: "VIEW ALL FAVORITES",
              to: "/favorites",
            })
          }}
          data-cy="favorite-dashboard-view-all"
        >
          <span>{" >> "}</span>VIEW ALL FAVORITES
        </Link>
      )}
    </ContentCard>
  )
}
